<app-grid
  *ngIf="!loading"
  #grid
  [columnDefs]="columDef"
  [rowData]="rowData"
  [rowSelection]="'multiple'"
  [selectedProject]="selectedProject"
  [suppressRowClickSelection]="true"
  [useSelectAll]="true"
  [pivotMode]="true"
  [pivotPanelShow]="'always'"
  [rowGroupPanelShow]="'always'"
  [groupDisplayType]="'multipleColumns'"
  [sideBar]="sideBar"
  [allowDragFromColumnsToolPanel]="true"
  [autoGroupColumnDef]="autoGroupColumnDef"
  [groupDefaultExpanded]="-1"
  [gridOptions]="gridOptions"
  (onSelectedRowEvent)="onSelectedRowEvent($event)"
  (onSelectAllClicked)="onSelectedAllChanged()"
/>

<app-loading *ngIf="loading"/>
